import store from "@/store"

const { body } = document
const WIDTH = 992 // refer to Bootstrap's responsive design

export default {
  watch: {
    //如果是移动端且侧边栏是展开状态，收起侧边栏
    $route(route) {
      if (this.device === "mobile" && this.openSidebar.opened) {
        store.dispatch("app/closeSideBar", { withoutAnimation: false })
      }
    }
  },
  beforeMount() {
    window.addEventListener("resize", this.$_resizeHandler)
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.$_resizeHandler)
  },
  mounted() {
    const isMobile = this.$_isMobile()
    if (isMobile) {
      //是手机端 切换设备为  手机端 关闭展开栏
      store.dispatch("app/toggleDevice", "mobile")
      store.dispatch("app/closeSideBar", { withoutAnimation: true })
    }
  },
  methods: {
    // use $_ for mixins properties
    // https://vuejs.org/v2/style-guide/index.html#Private-property-names-essential
    /**
     * @description: 判断是否是手机端
     * @return {*}
     * @author: syx
     */    
    $_isMobile() {
      const rect = body.getBoundingClientRect()
      // 顺带设置当前屏幕高度
      store.commit("app/SET_SCREEN_HEIGHT", rect.height)
      return rect.width - 1 < WIDTH
    },
    /**
     * @description: 窗口大小改变事件
     * @return {*}
     * @author: syx
     */    
    $_resizeHandler() {
      if (!document.hidden) {
        const isMobile = this.$_isMobile()
        store.dispatch("app/toggleDevice", isMobile ? "mobile" : "desktop")

        if (isMobile) {
          store.dispatch("app/closeSideBar", { withoutAnimation: true })
        }
      }
    }
  }
}
